import { call, CallEffect, select, SelectEffect, take, TakeEffect } from 'redux-saga/effects';
import { initializeSessionFail, initializeSessionSuccess } from '../../actions/users';
import { selectIsAdminUser, selectSessionInitializationAttempted } from '../../selectors/users';
function* isAdminHelper(): Generator<SelectEffect | TakeEffect, boolean, boolean> {
    const sessionInitializationAttempted = yield select(selectSessionInitializationAttempted);
    if (!sessionInitializationAttempted) {
        yield take([initializeSessionSuccess, initializeSessionFail]);
    }
    return yield select(selectIsAdminUser);
}
function* validateIsAdmin(): Generator<CallEffect, void, boolean | undefined> {
    const isAdmin = yield call(isAdminHelper);
    if (!isAdmin) {
        throw new Error('Not allowed');
    }
}
export { isAdminHelper, validateIsAdmin };
